<template>
  <div aria-hidden="true" class="visually-hidden"></div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from '../router/simpleRouter'
import { useHead } from '../seo/head'

const route = useRoute()
const domain = 'https://vampiroamascararpg.com.br'
const defaultKeywords = 'vampiro a máscara, ficha vampiro, rpg vampiro, clãs vampiro, disciplinas vampiro, v20, v5, ficha online vampiro'
const ogImage = `${domain}/og-image.svg`

const headDefinition = computed(() => {
  const title = route?.meta?.title || 'Vampiro A Máscara | Ficha Online, Clãs, Disciplinas e Regras'
  const description =
    route?.meta?.description ||
    'Explore fichas online de Vampiro A Máscara, descubra clãs, consulte disciplinas e regras completas para suas crônicas.'
  const keywords = route?.meta?.keywords || defaultKeywords
  const url = `${domain}${route?.path || '/'}`

  return {
    title,
    meta: [
      { name: 'description', content: description },
      { name: 'keywords', content: keywords },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:image', content: ogImage },
      { property: 'og:url', content: url },
      { property: 'og:type', content: 'website' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description }
    ],
    link: [
      { rel: 'canonical', href: url }
    ]
  }
})

useHead(() => headDefinition.value)
</script>
